import React from "react";
import { fontCss } from "./constants";

const WORD = new Set(["karaoke", "pop", "mrbeast"]);

// Live preview of the viral caption styles; mirrors backend render2.styled_text_png.
export const CaptionText = ({ o, px, gt }) => {
  const cs = o.cs, hl = o.hl || "#FFD60A";
  const text = cs === "mrbeast" ? String(o.text).toUpperCase() : String(o.text);
  const n = text.split(/\s+/).filter(Boolean).length || 1;
  const prog = Math.min(0.9999, Math.max(0, (gt - o.start) / Math.max(0.01, o.end - o.start))) * n;
  const k = WORD.has(cs) ? Math.floor(prog) : -1;
  const bounce = cs === "pop" ? Math.max(0, 1 - (prog - k) * 6) : 0;
  const sw = cs === "mrbeast" ? px * 0.14 : cs === "neon" || cs === "box" || cs === "minimal" || !o.stroke ? 0 : px * 0.08;
  const base = {
    color: cs === "neon" ? "#FFFFFF" : o.color, fontSize: px, ...fontCss(o.font), lineHeight: 1.25,
    WebkitTextStroke: sw ? `${sw}px #000` : undefined, paintOrder: "stroke fill",
    textShadow: cs === "neon" ? `0 0 ${px * 0.15}px ${o.color}, 0 0 ${px * 0.4}px ${o.color}, 0 0 ${px * 0.7}px ${o.color}`
      : cs === "mrbeast" ? `0 ${px * 0.09}px 0 #000` : cs === "box" ? "none" : cs === "minimal" ? "1px 2px 2px rgba(0,0,0,.35)" : "2px 3px 0 rgba(0,0,0,.55)",
  };
  let gi = 0;
  return (
    <span style={{ display: "block", textAlign: "center", whiteSpace: "pre" }} data-testid="caption-styled">
      {text.split("\n").map((line, li) => (
        <span key={li} style={{ display: "block" }}>
          <span style={cs === "box" ? { background: hl, borderRadius: px * 0.22, padding: `0 ${px * 0.3}px`, boxDecorationBreak: "clone", WebkitBoxDecorationBreak: "clone" } : undefined}>
            {line.split(" ").filter(Boolean).map((w, wi) => {
              const idx = gi++;
              const act = idx === k;
              const isEmo = /\p{Extended_Pictographic}/u.test(w);
              return (
                <React.Fragment key={wi}>
                  {wi > 0 && " "}
                  <span style={{ ...base, ...(isEmo ? { WebkitTextStroke: undefined, textShadow: "none" } : {}), color: act ? hl : base.color, visibility: cs === "pop" && idx > k ? "hidden" : "visible", display: "inline-block",
                    transform: act && bounce ? `scale(${1 + 0.25 * bounce})` : act && cs !== "pop" ? "scale(1.06)" : undefined, transition: "color .08s" }}>{w}</span>
                </React.Fragment>
              );
            })}
          </span>
        </span>
      ))}
    </span>
  );
};
